import { useEffect, useState } from "react";
import SideBarC from "../../stories/common/sidebar";
import styles from "./layout.module.scss";
import { Outlet } from "react-router-dom";
import useProperty from "../../hooks/context/useProperty";
import BottomBar from "../../stories/common/bottombar";

interface PropTypes {
  type: string;
}
const Layout = ({ type = "agent" }: PropTypes) => {
  const { collapsed, setCollapsed }: any = useProperty();
  const [toggled] = useState(false);
  function getPathIndex(): number {
    if (
      window.location.pathname === "/dashboard" ||
      window.location.pathname === "/investor/dashboard"
    ) {
      return 0;
    } else if (
      window.location.pathname === "/properties" ||
      window.location.pathname === "/investor/properties-listing"
    ) {
      return 1;
    } else if (window.location.pathname === "/inv-list") {
      return 2;
    } else if (window.location.pathname === "/calling-pipeline") {
      return 3;
    } else if (window.location.pathname === "/profile") {
      return 4;
    } else {
      return 1;
    }
  }
  const [activeIndex, setActiveIndex] = useState(() => {
    return getPathIndex();
  });
  useEffect(() => {
    setActiveIndex(() => getPathIndex());
    if (window.location.pathname === "/properties") {
      setCollapsed(true);
    }
  }, [window.location.pathname]);
  const handleMenuItemClick = (option: any) => {
    setActiveIndex(option);
  };

  const handleCollapsedChange = () => {
    setCollapsed(!collapsed);
  };

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const initialIndex = getPathIndex();
    setActiveIndex(initialIndex);
    if (window.location.pathname === "/properties") {
      setCollapsed(true);
    }

    // window.addEventListener("resize", handleResize);
    // return () => {
    //   window.removeEventListener("resize", handleResize);
    // };
  }, []);

  return (
    <>
      <div
        className={`${styles.layout} ${
          collapsed === true ? `${styles.collapsed}` : ""
        }`}
      >
        <SideBarC
          type={type}
          collapsed={collapsed}
          toggled={toggled}
          handleMenuItemClick={handleMenuItemClick}
          handleToggleSidebar={handleToggleSidebar}
          handleCollapsedChange={handleCollapsedChange}
          activeIndex={activeIndex}
        />
        <Outlet />
        <BottomBar type={type} />
      </div>
    </>
  );
};

export default Layout;
